document.addEventListener("DOMContentLoaded", function (){
  class YGDiscount extends HTMLElement {
    constructor() {
      super()
      this.init()
    }
    init() {
      // 这里放置初始化逻辑
      this.clickCopy()
    }
    clickCopy() {
      // 这里放置自定义逻辑
      let $copyBtn = this.querySelector('.product-info__discount-button')
      let copyText = $copyBtn.getAttribute('data-code-text')
      let copyBtnText = $copyBtn.innerHTML
  
      $copyBtn.addEventListener('click', function () {
        navigator.clipboard.writeText(copyText).then(
          () => {
            $copyBtn.innerHTML = 'SUCCESS !'
            setTimeout(() => {
              $copyBtn.innerHTML = copyBtnText
            }, 3000)
          },
          () => {
            $copyBtn.innerHTML = 'FAILURE !'
            setTimeout(() => {
              $copyBtn.innerHTML = copyBtnText
            }, 3000)
          }
        )
      })
    }
  }
  if (!window.customElements.get('yg-discount')) {
    window.customElements.define('yg-discount', YGDiscount)
  }
  
  class YGVariantTab extends HTMLElement {
      constructor() {
          super()
          this.init()
      }
      init() {
          // 这里放置初始化逻辑
          this.taggerContent()
      }
      taggerContent() {
          // 这里放置自定义逻辑
          let $tabList = this.querySelectorAll('.yg-tab__title')
          let $parentElement =  this.closest('.quick-buy-modal') || this.closest('.product-info__block-list')
  
          if (!$parentElement.getAttribute('data-tab')) {
            $parentElement.setAttribute('data-tab', $tabList[0].getAttribute('data-tab'))
          }
          
          $parentElement.addEventListener('click', function(e){
            if (e.target.classList.contains('yg-tab__title')) {
              $parentElement.setAttribute('data-tab', e.target.getAttribute('data-tab'))
            }
          })
      }
  }
  if (!window.customElements.get('yg-variant-tab')) {
      window.customElements.define('yg-variant-tab',YGVariantTab)
  }
  
  class YGIconList extends HTMLElement {
      constructor() {
          super()
          this.init()
      }
      init() {
          // 这里放置初始化逻辑
          this.intoSwiper()
      }
      intoSwiper() {
        // 这里放置自定义逻辑
        new Swiper(this,{
          slidesPerView: 1,
          spaceBetween: 10,
          breakpoints: { 
            700: {  //当屏幕宽度大于等于768 
              slidesPerView: 2,
              spaceBetween: 10
            },
            1024: {  //当屏幕宽度大于等于768 
              slidesPerView: 3,
              spaceBetween: 10
            }
          },
          pagination: {
              el: '.swiper-pagination',
            },
          })
        
      }
  }
  if (!window.customElements.get('yg-icon-list')) {
      window.customElements.define('yg-icon-list',YGIconList)
  }
  
  class YGTab extends HTMLElement {
      constructor() {
          super()
          this.init()
      }
      init() {
          // 这里放置初始化逻辑
          this.taggerContent()
      }
      taggerContent() {
          // 这里放置自定义逻辑
          let $tabTitleList = this.querySelectorAll('.yg-tab-title')
          let $tabContentList = this.querySelectorAll('.yg-tab-content')
  
          $tabTitleList.forEach(($tabTitle, i) => {
            $tabTitle.addEventListener('click', function(){
              $tabTitleList.forEach(($tabTitle) => {
                $tabTitle.classList.remove('active')
              })
              $tabContentList.forEach(($tabContent) => {
                $tabContent.classList.remove('active')
              })
              $tabTitle.classList.add('active')
              $tabContentList[i].classList.add('active')
            })
          })
      }
  }
  if (!window.customElements.get('yg-tab')) {
      window.customElements.define('yg-tab',YGTab)
  }

  // setTimeout(() => {
  //   const labelList = document.querySelectorAll('[yg-listen-mark="label_1"]');

  //   function handleElementClick(event) {
  //     const clickedElement = event.currentTarget;
  //     console.log('clickedElement: ', clickedElement);

  //     const grandfatherElement = event.target.parentElement.parentElement;
  //     console.log('grandfatherElement: ', grandfatherElement);

  //     if (grandfatherElement) {
  //       const newTextSpan = clickedElement.querySelector('span');
  //       console.log(newTextSpan);

  //       if (newTextSpan) {
  //         const newText = newTextSpan.textContent;
  //         console.log('text: ', newText);

  //         grandfatherElement.querySelector('[yg-change-mark="span_1"] span').textContent = newText;
  //       }
  //     }
  //   }

  //   // 为每个元素添加点击事件监听器
  //   labelList.forEach((element) => {
  //     element.addEventListener('click', handleElementClick);
  //   });
  // }, 1000);
})
